// Doctor-facing AI pre-consultation triage summary.
// Shows the RAG grade + the concise clinician SBAR brief that the chatbot
// synthesized before the consultation. Renders nothing without a summary.

import TriageBadge, { ragOf } from './TriageBadge.jsx'

const ACCENT = {
  red: 'border-l-red-500 bg-red-50',
  amber: 'border-l-amber-500 bg-amber-50',
  green: 'border-l-emerald-500 bg-emerald-50',
}

export default function TriageSummaryCard({ severity, summary, className = '' }) {
  if (!summary) return null
  const accent = ACCENT[severity] || 'border-l-slate-400 bg-slate-50'
  const rag = ragOf(severity)
  return (
    <section className={`border-l-4 ${accent} rounded-r px-3 py-2.5 ${className}`}>
      <div className="flex items-center justify-between gap-2 mb-1.5">
        <span className="text-xs font-semibold text-slate-700">
          AI pre-consultation triage
        </span>
        {rag && <TriageBadge severity={severity} />}
      </div>
      <pre className="whitespace-pre-wrap font-sans text-xs text-slate-700 leading-relaxed m-0">
        {summary}
      </pre>
      <p className="text-[10px] text-slate-400 mt-1.5 m-0">
        Patient-reported, rules-graded. Not a diagnosis — confirm at the encounter.
      </p>
    </section>
  )
}
